import { render } from "./AzureLogin.vue?vue&type=template&id=1d8cb6b3&scoped=true"
import script from "./AzureLogin.vue?vue&type=script&lang=js"
export * from "./AzureLogin.vue?vue&type=script&lang=js"

import "./AzureLogin.vue?vue&type=style&index=0&id=1d8cb6b3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d8cb6b3"]])

export default __exports__